import * as React from "react";
import * as M from "../../models";
import { WrapperLess } from "../generic";
import { FieldDisplay } from "./FieldDisplay";

interface OwnProps {
    section: M.FormBuilder.FormSection;
}

interface OwnState {
}

export class FieldSectionDisplay extends React.Component<OwnProps, OwnState> {
    public render() {
        const s = this.props.section;
        const fields = (s.fields || []).map((f, i) => <FieldDisplay field={f} key={i} />);

        const title = s.title
            ? <h2>{s.title}</h2>
            : null;

        const description = s.description
            ? <div dangerouslySetInnerHTML={{ __html: s.description }} />
            : null;

        return <WrapperLess>
            {title}
            {description}
            {fields}
        </WrapperLess>;
    }
}



// WEBPACK FOOTER //
// ./src/components/formBuilder/FieldSectionDisplay.tsx